import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import ProductCover from 'Components/Utility/ProductCover';
import useViewport from 'Hooks/useViewport';

import 'Components/Carousel/FeaturedCarouselPanels/PanelComponents/ScreenshotCarousel.scss';

const HitsCarousel = ({
  hits,
  switchCoverImg,
  type,
}) => {
  const [sliderPosition, setSliderPosition] = useState(0);
  const [activeGameNumber, setActiveGameNumber] = useState(0);

  const { isAboveXl } = useViewport();

  if (isEmpty(hits)) return false;

  const numberOfRows = 1;

  // Splitting the slides into columns depending on how many rows we want to show
  let carouselSlides = cloneDeep(hits);
  if (numberOfRows === 2) {
    carouselSlides = carouselSlides.slice(0, 8);
  }
  const slides = [];
  while (carouselSlides.length > 0) {
    slides.push(carouselSlides.splice(0, numberOfRows));
  }

  if (!isEmpty(slides) && slides.length === 1) return false;

  let slideWidth = 144;
  if (isAboveXl) slideWidth = 192;
  const sliderGap = 8;

  const loadNext = () => {
    setSliderPosition(sliderPosition - (slideWidth + sliderGap));
    setActiveGameNumber(activeGameNumber + 1);
  };

  const loadPrevious = () => {
    setSliderPosition(sliderPosition + (slideWidth + sliderGap));
    setActiveGameNumber(activeGameNumber - 1);
  };

  return (
    <>
      <div className="ImageCarousel CarouselPanel__section">
        <div className="ImageCarousel__slides" style={{ left: `${sliderPosition}px` }}>
          {!isEmpty(slides) && slides.map(slide =>
            <div
              className="ImageCarousel__slides__slide responsive-image-island"
              style={{ width: slideWidth }}
              key={slide[0].cover}
              onMouseEnter={() => { switchCoverImg({ cover: slide[0].cover, hit: slide[0], type: slide[0].type }); }} // eslint-disable-line max-len
              onMouseLeave={() => { switchCoverImg(); }}
            >
              <div className="ImageCarousel__slides__slide__image responsive-image--16by9">
                {type === 'category' &&
                  <Link to={`${slide[0].type}/${slide[0].slug}`}>
                    <ProductCover
                      thumbnail
                      cover={slide[0].cover}
                      alt={`Product cover for ${slide[0].name}`}
                      displayType={slide[0].type}
                    />
                  </Link>
                }
                {type !== 'category' &&
                  <ProductCover
                    thumbnail
                    cover={slide[0].cover}
                    alt={`Product cover for ${slide[0].name}`}
                    displayType={slide[0].type}
                  />
                }
              </div>
            </div>,
          )}
        </div>

        <button
          className="ImageCarousel__leftButton"
          disabled={activeGameNumber === 0}
          onClick={() => { loadPrevious(); }}
        >
          <FontAwesomeIcon icon={faChevronLeft} title="Previous" />
        </button>
        <button
          className="ImageCarousel__rightButton"
          disabled={activeGameNumber + 1 === slides.length}
          onClick={() => { loadNext(); }}
        >
          <FontAwesomeIcon icon={faChevronRight} title="Next" />
        </button>
      </div>
    </>
  );
};

HitsCarousel.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape()),
  switchCoverImg: PropTypes.func,
  type: PropTypes.string,
};

HitsCarousel.defaultProps = {
  hits: [],
  switchCoverImg: () => {},
  type: '',
};

export default HitsCarousel;
